import $ from "utils/net";
import Config from "./config";
import { Component } from "preact";

/**
 * Rappresenta un Voucher nel sistema
 */
export interface Voucher {
    id: string;
    amount: number;
    currency: string;
    created_time: number;
    redeemed_time: number | null;
    redeemed_account: string | null;
    approved: boolean;
}

/**
 * Struttura standard per gli errori dei voucher
 */
export interface VoucherError {
    status: "error";
    errors: string[];
}

/**
 * Risposta dell'API per la creazione di un voucher
 */
interface CreateVoucherResponse {
    status: string;
    errors?: string[];
    voucher: Voucher;
}

/**
 * Risposta dell'API per il riscatto di un voucher
 */
interface RedeemVoucherResponse {
    status: string;
    voucher: string;
    'voucher-amount': number;
    'voucher-currency': string;
    errors?: string[];
}

/**
 * Risposta dell'API per le liste di voucher
 */
interface ListVouchersResponse {
    status: 'ok' | 'error';
    vouchers: Voucher[];
    errors?: string[];
}

export default class Vouchers extends Component<any, any> {
    render() {
        return null;
    }
    /**
     * Voucher in valuta del giocatore. Eccezione nella forma {status:"", errors:["", "", ...]}
     * @param {number} amount   Importo
     */
    async createVoucher(amount: number): Promise<CreateVoucherResponse> {
        const request = new Promise<CreateVoucherResponse>((res, rej) => $.post(Config.softionAPI + '/voucher/create', {
            json: true,
            body: { amount: amount }
        }, (err: any, data: CreateVoucherResponse) => {
            if (err) {
                console.error(err);
                rej({ status: "error", errors: ['network'] } as VoucherError);
            }
            return res(data);
        }));

        const data = await request;
        if (data.status == 'error')
            throw data;

        return {
            status: data.status,
            errors: data.errors,
            voucher: data.voucher
        };
    }

    /**
     * Dai a te stesso giocatore i soldi di questo voucher
     * @param {string} id Codice del voucher inserito dal giocatore
     */
    async redeemVoucher(id: string): Promise<RedeemVoucherResponse> {
        const request = new Promise<RedeemVoucherResponse>((res, rej) => $.post(Config.softionAPI + '/voucher/redeem', {
            json: true,
            body: { id: id }
        }, (err: any, data: RedeemVoucherResponse) => {
            if (err) {
                console.error(err);
                rej({ status: "error", errors: ['network'] } as VoucherError);
            }
            return res(data);
        }));

        const data = await request;
        if (data.status == 'error')
            throw data;

        return {
            status: data.status,
            voucher: data.voucher,
            'voucher-amount': data['voucher-amount'],
            'voucher-currency': data['voucher-currency'],
        };
    }

    /**
     * Lista i voucher attivi
     * @return {Promise<Voucher[]>}
     */
    async listActiveVouchers(): Promise<Voucher[]> {
        const request = new Promise<ListVouchersResponse>((res, rej) => $.getJSON(Config.softionAPI + '/voucher/getList/active', (err: any, data: ListVouchersResponse) => {
            if (err) {
                console.error(err);
                rej({ status: "error", errors: ['network'] } as VoucherError);
            }
            return res(data);
        }));

        const data = await request;
        if (data.status == 'error')
            throw data;

        return data.vouchers;
    }

    /**
     * Lista i voucher già riscattati o expired
     * @return {Promise<Voucher[]>}
     */
    async listExpiredVouchers(): Promise<Voucher[]> {
        const request = new Promise<ListVouchersResponse>((res, rej) => $.getJSON(Config.softionAPI + '/voucher/getList/expired', (err: any, data: ListVouchersResponse) => {
            if (err) {
                console.error(err);
                rej({ status: "error", errors: ['network'] } as VoucherError);
            }
            return res(data);
        }));

        const data = await request;
        if (data.status == 'error')
            throw data;

        return data.vouchers;
    }
}